import { FieldValues, Path } from "react-hook-form";
import { Props } from "./FormField.Parts";
import { CheckboxField } from "./fields/checkbox-field/CheckboxField";
import { DateField } from "./fields/date-field/DateField";
import { EntryListField } from "./fields/entry-list-field/EntryListField";
import { RadioField } from "./fields/radio-field/RadioField";
import { SecretField } from "./fields/secret-field/SecretField";
import { SelectField } from "./fields/select-field/SelectField";
import { TextAreaField } from "./fields/text-area-field/TextAreaField";
import { TextField } from "./fields/text-field/TextField";
import { ToggleField } from "./fields/toggle-field/ToggleField";

export const FormField = <
  FormFields extends FieldValues,
  FieldName extends Path<FormFields>,
>(
  props: Props<FormFields, FieldName>,
) => {
  switch (props.type) {
    case "select":
      return <SelectField {...props} />;
    case "radio":
      return <RadioField {...props} />;
    case "checkbox":
      return <CheckboxField {...props} />;
    case "toggle":
      return <ToggleField {...props} />;
    case "textarea":
      return <TextAreaField {...props} />;
    case "date":
      return <DateField {...props} />;
    case "entrylist":
      return <EntryListField {...props} />;
    case "secret":
      return <SecretField {...props} />;
    default:
      return <TextField {...props} />;
  }
};
